import { Row, Col, Button } from 'react-bootstrap'
import { fetchAllLocationByQRId, fetchSitesWithParentCompany } from '../../Redux/Api/fetch.api';
import { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useDispatch } from 'react-redux';
import { updateLocationByQRCode } from '../../Redux/Actions/QR';
import toast, { Toaster } from 'react-hot-toast';
import UploadMedia from './UploadMedia';
import Loader from '../loader';
import { useTranslation } from "react-i18next";
const SiteCompanyQR = ({ locationIdByQRId, showScanner, newQR, id, qrcode, companyData, setLocationIdByQRId, getCompaniesBySiteId, setIsSiteCompanyShow, setNewQR, setqrcode, setValidQrError, data }) => {
    console.log(companyData, "companyData in SiteCompanyQR");
    const { t } = useTranslation("dashboard");
    const dispatch = useDispatch()
    const [siteData, setSiteData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentLocationIdShow, setCurrentLocationIdShow] = useState();
    const [filteredSiteOptions, setFilteredSiteOptions] = useState([]);
    const [currentCompanyLocationId, setcurrentCompanyLocationId] = useState();
    const [companyName, setCompanyName] = useState([]);
    const [locationName, setLocationName] = useState([]);
    const [siteName, setSiteName] = useState([]);
    const [isUploadMediaShow, setIsUploadMediaShow] = useState(false)
    const [currentLocationId, setCurrentLocationId] = useState();
    const [currentCompanyId, setCurrentCompanyId] = useState();

    useEffect(() => {
        getAllSites()
    }, [])

    const getAllSites = () => {
        setLoading(true)
        fetchSitesWithParentCompany()
            //  fetchSiteDetails()
            .then(response => {

                if (response.data.success) {
                    setSiteData(response.data.data)
                }
                //  const matchedSite = response.data.data.find(site => site.siteId === currentLocationId);
                //     if (matchedSite) {
                //         setLocationName(matchedSite.parentCompanyName);

                //     }
                setLoading(false)
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }
    const handleInputForSiteDropdown = (input) => {

        const filtered = siteData && siteData.filter(item => {
            const fullName = item.siteName;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredSiteOptions(filtered);
    };

    const getCompanyLocationTypeData = (e) => {
        debugger;
        const selectedValue = e; // Format: siteId|companyId

        setcurrentCompanyLocationId(selectedValue);



        // Find the correct record using BOTH siteId and companyId
        let selectedRecord = siteData.find(
            x => x.siteId === selectedValue
        );

        if (selectedRecord) {
            setCurrentLocationId(selectedRecord.siteId);
            setCurrentCompanyId(selectedRecord.companyId);
            setCompanyName(selectedRecord.parentCompanyName);
            setSiteName(selectedRecord.siteName + " - " + selectedRecord.parentCompanyName);

        }
    };


    const updateLocationByQRId = async (e) => {

        setLocationIdByQRId(parseInt(currentLocationIdShow));
        getCompaniesBySiteId(currentLocationIdShow)
        fetchAllLocationByQRId(newQR || id || qrcode, currentLocationIdShow)
            .then(response => {
                dispatch(updateLocationByQRCode(response.data))
                toast.success(response.data.message, {
                    className: "toastSuccess",
                },);
                setIsUploadMediaShow(true);
            })
            .catch((err) => {
                console.log("Err: ", err);

            });
    };

    const handleClearStates = () => {
        setNewQR("")
        setIsSiteCompanyShow(false)
        setqrcode("")
        setValidQrError("")
    }
    return (
        <div>
            <Toaster />
            {loading ? <Loader /> : ''}
            {!isUploadMediaShow && <div>
                {!showScanner && locationIdByQRId == 1 ?
                    <section className="detail-code text-left">

                        <div className="inner-head">
                            <h4>{t("QRLabel")}<strong>{newQR || id || qrcode}</strong></h4>

                        </div>

                        <Row className="form-box row-gap-3">
                            <Col lg={6}>

                                <div className="form-group">
                                    <label>
                                        {t("Site")}<sup className="text-danger">*</sup>
                                    </label>
                                    <div className="input-group">
                                        <Select class="form-select mb-0  filter-select"
                                            aria-label=".form-select-lg example"
                                            showSearch
                                            value={currentLocationIdShow ? currentLocationIdShow : "Select Site"}
                                            style={{ width: 450 }}
                                            onSearch={(value) => {
                                                handleInputForSiteDropdown(value)
                                            }}
                                            filterOption={false}
                                            onChange={(e) => {
                                                if (e != 0) {
                                                    setCurrentLocationIdShow(e);
                                                    getCompanyLocationTypeData(e)
                                                }
                                            }}>
                                            {/*    <Option value="0">                                                                                                    */}
                                            {/*</Option>*/}
                                            {filteredSiteOptions.length > 0 ?
                                                filteredSiteOptions && filteredSiteOptions.map(item =>
                                                    <Option key={item.siteId} value={item.siteId}>
                                                        {`${item.siteName} - ${item.parentCompanyName}`}
                                                    </Option>
                                                )
                                                :
                                                siteData && siteData.map(item =>
                                                    <Option key={item.siteId} value={item.siteId}>
                                                        {`${item.siteName} - ${item.parentCompanyName}`}
                                                    </Option>
                                                )
                                            }
                                        </Select>
                                    </div>
                                    <div class="mt-2">
                                        {currentLocationIdShow ?
                                            <button type="button" class="btn btn-primary" onClick={(e) => updateLocationByQRId(e)}>{t("Submit")}</button>
                                            :
                                            <button type="button" class="btn btn-primary" disabled onClick={(e) => updateLocationByQRId(e)}>{t("Submit")}</button>
                                        }
                                    </div>
                                </div>
                            </Col> </Row>
                    </section > : ''}
                {/* This block only shows when showScanner is false AND locationIdByQRId is NOT 1 */}

                {/* <section className="detail-code text-left">
                {!showScanner && locationIdByQRId > 1 ? (
                    <>
                        <div className="inner-head">
                            <h4>QR: <strong>{newQR || id || qrcode}</strong></h4>
                            
                        </div>

                        <Row className="form-box row-gap-3">
                            <Col lg={6}>

                                <div className="form-group">
                                    <label>
                                        Site <sup className="text-danger">*</sup>
                                    </label>
                                    <div className="input-group">
                                        <select class="form-select mb-0  filter-select" aria-label=".form-select-lg example" value={currentCompanyLocationId}
                                            onChange={(e) => getCompanyLocationTypeData(e)}>
                                            <option selected="">Select Site</option>
                                            {companyData &&
                                                companyData.map(record => (
                                                    <option key={record.siteId + "|" + record.companyId} value={record.siteId + "|" + record.companyId}>
                                                        {record.siteName + " - " + record.companyName}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                            </Col>

                            <Col lg={6}>
                                <div className="form-group">
                                    <label>Company Name</label>
                                    <div className="input-group">
                                        <label id="text" type="text" className="form-control" name="text" placeholder="Enter Company Name">{companyName}</label>
                                       
                                    </div>
                                </div>
                            </Col>
                             <div className="d-flex gap-3 justify-content-end w-100">
                            <Button className="btn btn-bordered w-100 lg-w-auto" onClick={() => handleClearStates()}>Back</Button>
                           {console.log("locationName, companyName, currentCompanyId,currentLocationId, currentCompanyLocationId: ",locationName, companyName, currentCompanyId,currentLocationId, currentCompanyLocationId )}
                           
                            {locationName && companyName && currentCompanyId && currentLocationId && currentCompanyLocationId != 0 && currentCompanyLocationId !== 'Select Site' ?<Button className="btn w-100 lg-w-auto" onClick={()=>setIsUploadMediaShow(true)}>Continue</Button>: <Button className="btn w-100 lg-w-auto" onClick={()=>setIsUploadMediaShow(true)} disabled>Continue</Button>}
                        </div>
                        </Row>

                       
                    </>
                ) : null}
            </section> */}

            </div>}

            {
                isUploadMediaShow && siteName && <UploadMedia
                    SiteName={siteName}
                    Id={id}
                    QRCode={qrcode}
                    NewQR={newQR}
                    SetIsUploadMediaShow={setIsUploadMediaShow}
                    CompanyData={companyData}
                    CurrentLocationId={currentLocationId}
                    CurrentCompanyId={currentCompanyId}
                    Data={data}
                    setCompanyName={setCompanyName}
                    CurrentCompanyLocationId={currentCompanyLocationId}
                    CompanyName={companyName} />
            }
        </div>

    )
}
export default SiteCompanyQR
